import React, { useEffect, useState } from 'react';
import "./Pricing.scss";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonGroup, Container, Grid, Typography } from '@mui/material';
import { FaCheck, FaChevronDown } from 'react-icons/fa';
import WatchVideo from '../WatchVideo/WatchVideo';
import offTag from "../../assets/images/20-image.png";
import Footer from '../footer/footer';
import { buildFAQSchema, buildSoftwareSchema } from '../../utils/schemaBuilders';
import SchemaMarkup from '../SchemaMarkup/SchemaMarkup';
import { sitePlans, siteFaqs } from '../../utils/siteData';

const Pricing = () => {

    const [expanded, setExpanded] = useState(false);
    const [activeButton, setActiveButton] = useState(1)
    const [openDemoModel, setOpenDemoModel] = useState(false);
    const handleClose = () => setOpenDemoModel(false);

    const totalPrice = {
        basic: "$150",
        standard: "$300",
        premium: "$600"
    }
    const comparePlans = [
        {
            feature: 'Max number of employees',
            basicPlan: '15',
            standardPlan: '30',
            premiumPlan: '60',
            link: '',
        },
        {
            feature: 'Web and mobile access',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
            feature: 'GPS verification',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: 'https://ezclocker.com/time-tracking/gps-mobile-app/index.html',
        },
        {
            feature: 'Employee scheduling',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: 'https://ezclocker.com/time-tracking/employee-scheduling-software/index.html',
        },
        {
            feature: 'Kiosk App',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: 'https://ezclocker.com/time-tracking/portable-time-clock-kiosk-app/index.html',
        },
        {
            feature: 'Export timesheet reports',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
            feature: 'Customer support',
            basicPlan: <FaCheck />,
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
            feature: 'Jobs tracking',
            basicPlan: '',
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: 'https://ezclocker.com/time-tracking/job-tracking-software/index.html',
        },
        {
            feature: 'Geofence',
            basicPlan: '',
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
             feature:"Time off",
             basicPlan:'',
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
            feature: 'Overtime reports',
            basicPlan: '',
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: '',
        },
        {
            feature: 'Payroll integration',
            basicPlan: '',
            standardPlan: <FaCheck />,
            premiumPlan: <FaCheck />,
            link: 'https://ezclocker.com/time-tracking/integrations/index.html',
        },
    ];
    const comparePlansHeads=[
        "Features","Basic Plan","Standard Plan","Premium Plan"
    ]

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleButtonClick = (index) => {
        setActiveButton(index)
    }
     const showDetails = (link) => {
             window.location.href = link;
     };

const navigateToSignup = () => {
    window.location.href = 'https://ezclocker.com/public/signup.html?v=r73.9.3';
};

    useEffect(() => {
        document.title = 'ezClocker Pricing. Simple & Budget-Friendly | ezClocker';

        const metaTag = document.createElement('meta');
        metaTag.name = 'description';
        metaTag.content = `See ezClocker's affordable pricing plans. No hidden fees, no contracts. Perfect for small businesses. Try it free for 30 days.`;
        document.head.appendChild(metaTag);
        window.scrollTo(0, 0);
    }, []);

    const softwareSchema = buildSoftwareSchema(sitePlans);
    const faqSchema = buildFAQSchema(siteFaqs);

    return (<>
        <SchemaMarkup schema={softwareSchema} />
        <SchemaMarkup schema={faqSchema} />
        <div className="pricingPage">
            <Box id="plans">
                <Container>
                    <Grid
                        container
                        justifyContent={'center'}
                    >
                        <Grid
                            item
                            xs={12}
                            id="intro-text-col"
                        >
                            <h3>The ezClocker subscription plans allow you to grow your subscription with your business</h3>
                        </Grid>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '1vw',
                                width: '100%',
                            }}
                        >
                            <Button
                                onClick={navigateToSignup}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#ff9900',
                                    color: '#fff',
                                    height: '44px',
                                }}
                            >
                                Get Your Free Trial Now!
                                <div className="dots-1"></div>
                            </Button>

                            <Button
                                onClick={() => setOpenDemoModel(true)}
                                variant="outlined"
                                className="start-button"
                                sx={{
                                    height: '44px',
                                    border: '1px solid #f68c2b',
                                    color: '#f68c2b',
                                }}
                            >
                                Watch a Demo
                            </Button>

                            <WatchVideo
                                openDemoModel={openDemoModel}
                                handleClose={handleClose}
                            />
                        </Box>

                        <Grid
                            item
                            xs={12}
                            id="intro-sub-text-col"
                        >
                            <Grid
                                container
                                className="intro-row"
                                justifyContent="center"
                            >
                                <Grid
                                    item
                                    xs={12}
                                >
                                    <div className="plans-button-wrapper">
                                        <ButtonGroup
                                            color="primary"
                                            aria-label="contained primary button group"
                                            className="plan-btns-group"
                                        >
                                            <Button
                                                className={activeButton === 0 ? 'active' : ''}
                                                onClick={() => handleButtonClick(0)}
                                            >
                                                Monthly
                                            </Button>
                                            <Button
                                                className={activeButton === 1 ? 'active' : ''}
                                                onClick={() => handleButtonClick(1)}
                                            >
                                                Annual
                                            </Button>
                                        </ButtonGroup>
                                        {activeButton === 1 && (
                                            <img
                                                alt="off"
                                                src={offTag}
                                                className="plan-off-tag"
                                            />
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        id="planRow"
                        justifyContent={'center'}
                    >
                        <Grid
                            item
                            x={12}
                            id="monthly"
                        >
                            <Grid
                                container
                                direction={{ sm: 'column', md: 'row' }}
                                spacing={4}
                                justifyContent={'center'}
                            >
                                <Grid
                                    item
                                    md={4}
                                >
                                    <div
                                        className="card"
                                        id="card"
                                    >
                                        <div className="card-header">
                                            <div className="text-center plan-name">
                                                <h2>Basic</h2>
                                                <h3>
                                                    {activeButton === 1 && <span className="strike-through">{sitePlans.basic.monthly}</span>}
                                                    {activeButton === 0 ? sitePlans.basic.monthly : sitePlans.basic.annual} /mo
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="card-block">
                                            <div
                                                className="card-title"
                                                align="left"
                                            >
                                                <h5>Up to 15 employees</h5>
                                            </div>
                                            <ul>
                                                {activeButton === 1 && (
                                                    <li>
                                                        <span>{totalPrice.basic} a year</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span>Web and mobile access</span>
                                                </li>
                                                <li>
                                                    <span>Employee scheduling</span>
                                                </li>
                                                <li>
                                                    <span>GPS verification</span>
                                                </li>
                                                <li>
                                                    <span>Export Pay Periods to CSV file</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    md={4}
                                >
                                    <div
                                        className="card"
                                        id="card"
                                    >
                                        <div className="card-header">
                                            <div className="text-center plan-name">
                                                <h2>Standard</h2>
                                                <h3>
                                                    {activeButton === 1 && <span className="strike-through">{sitePlans.standard.monthly}</span>}
                                                    {activeButton === 0 ? sitePlans.standard.monthly : sitePlans.standard.annual} /mo
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="card-block">
                                            <div
                                                className="card-title"
                                                align="left"
                                            >
                                                <h5>Up to 30 employees</h5>
                                            </div>
                                            <ul>
                                                {activeButton === 1 && (
                                                    <li>
                                                        <span>{totalPrice.standard} a year</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span>Web and mobile access</span>
                                                </li>
                                                <li>
                                                    <span>Employee scheduling</span>
                                                </li>
                                                <li>
                                                    <span>GPS verification</span>
                                                </li>
                                                <li>
                                                    <span>Export Pay Periods to CSV file</span>
                                                </li>
                                                <li>
                                                    <span>Job Assignments</span>
                                                </li>
                                                <li>
                                                    <span>Overtime Reports</span>
                                                </li>
                                                <li>
                                                    <span>Payroll Integrations</span>
                                                </li>
                                                <li>
                                                    <span>Time Off</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    md={4}
                                >
                                    <div
                                        className="card"
                                        id="card"
                                    >
                                        <div className="card-header">
                                            <div className="text-center plan-name">
                                                <h2>Premium</h2>
                                                <h3>
                                                    {activeButton === 1 && <span className="strike-through">{sitePlans.premium.monthly}</span>}
                                                    {activeButton === 0 ? sitePlans.premium.monthly : sitePlans.premium.annual} /mo
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="card-block">
                                            <div
                                                className="card-title"
                                                align="left"
                                            >
                                                <h5>Up to 60 employees</h5>
                                            </div>
                                            <ul>
                                                {activeButton === 1 && (
                                                    <li>
                                                        <span>{totalPrice.premium} a year</span>
                                                    </li>
                                                )}
                                                <li>
                                                    <span>Web and mobile access</span>
                                                </li>
                                                <li>
                                                    <span>Employee scheduling</span>
                                                </li>
                                                <li>
                                                    <span>GPS verification</span>
                                                </li>
                                                <li>
                                                    <span>Export Pay Periods to CSV file</span>
                                                </li>
                                                <li>
                                                    <span>Job Assignments</span>
                                                </li>
                                                <li>
                                                    <span>Overtime Reports</span>
                                                </li>
                                                <li>
                                                    <span>Payroll Integrations</span>
                                                </li>
                                                <li>
                                                    <span>Time Off</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center" mt={2} >
                                    <h4 style={{fontSize:"24px"}}>
                                        Do you have more than 60 employees?{" "}
                                        <a
                                            href="https://ezclocker.com/contact"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ textDecoration: "underline", fontWeight: "bold",fontSize:"24px", marginBottom:"5px"}}
                                        >
                                            contact us
                                        </a>
                                    </h4>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box
                className="bg-light"
                id="features"
            >
                <Container>
                    <Grid
                        container
                        spacing={2}
                        justifyContent={'center'}
                    >
                        <Grid
                            item
                            className="sect-header"
                        >
                            <h2>Compare Our Plans</h2>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={{ xs: 0, md: 12 }}
                        justifyContent={'center'}
                        className="features-row"
                    >
                        <Grid size={{ md: 10 }}>
                            <div className="plans-table">
                                <table
                                    cellPadding={'0'}
                                    cellSpacing={'0'}
                                >
                                    <thead>
                                        <tr>
                                            {comparePlansHeads.map((plan, index) => (
                                                <th className="text-center">{plan}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comparePlans.map((item, index) => (
                                            <tr>
                                                <td
                                                    onClick={() => showDetails(item.link)}
                                                    className={item.link !== '' ? 'clickable-item' : ''}
                                                >
                                                    {item.feature}
                                                </td>
                                                <td className="text-center">{item.basicPlan}</td>
                                                <td className="text-center">{item.standardPlan}</td>
                                                <td className="text-center">{item.premiumPlan}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Box id="faq">
                <Container>
                    <Grid
                        container
                        justifyContent={'center'}
                    >
                        <Grid
                            item
                            className="sect-header"
                        >
                            <h2>Frequently asked Questions</h2>
                        </Grid>
                    </Grid>
                    {siteFaqs.map((faq) => (
                        <Accordion
                            key={faq.id}
                            expanded={expanded === faq.id}
                            onChange={handleChange(faq.id)}
                        >
                            <AccordionSummary
                                expandIcon={<FaChevronDown color="#0f4777" />}
                                aria-controls={`${faq.id}-content`}
                                id={`${faq.id}-header`}
                            >
                                <Typography className="accordion-title">{faq.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography dangerouslySetInnerHTML={{ __html: faq.answer }} />
                            </AccordionDetails>
                        </Accordion>
                    ))}
                    <Grid
                        container
                        id="gotmoreq"
                        textAlign="center"
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ minHeight: '80px' }}
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <h5>Got more questions?</h5>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <p>
                                Send us an email to:&nbsp;
                                <a href="mailto:info@ezclocker.com">
                                    <strong>info@ezclocker.com</strong>
                                </a>
                            </p>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Footer />
        </div></>
    );
};

export default Pricing;
